export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "badge_agent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proposé par l'agent"])},
        "badge_added": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouté"])},
        "remove_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retirer cette demande"])},
        "current_value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réponse actuelle :"])},
        "no_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["aucun fichier"])},
        "files_count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["aucun fichier"]), _normalize(["1 fichier"]), _normalize([_interpolate(_named("count")), " fichiers"])])},
        "no_answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["non renseignée"])},
        "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oui"])},
        "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non"])},
        "message_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Message au client pour ce point (optionnel)"])}
      },
      "en": {
        "badge_agent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suggested by the agent"])},
        "badge_added": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Added"])},
        "remove_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remove this request"])},
        "current_value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Current answer:"])},
        "no_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["no file"])},
        "files_count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["no file"]), _normalize(["1 file"]), _normalize([_interpolate(_named("count")), " files"])])},
        "no_answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["not provided"])},
        "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes"])},
        "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No"])},
        "message_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Message to the customer for this item (optional)"])}
      }
    }
  })
}
